/**
 * @param {string} language
 * @param {string | undefined} [encodedParameters]
 * @param {string | undefined} [text]
 * @param {Array<string> | undefined} [termIds]
 * @param {GeoFilter | undefined} [geoFilter]
 * @param {number} [limit=20]
 * @param {number} [offset=0]
 * @param {boolean} [includeTermCounts=true]
 * @param {boolean} [includeLocations=true]
 * @param {boolean} [useLocationsFormat=true]
 * @returns {SearchParams}
 */
const createJobSearchParams = (
  language,
  encodedParameters,
  text,
  termIds,
  geoFilter,
  limit = 20,
  offset = 0,
  includeTermCounts = true,
  includeLocations = true,
  useLocationsFormat = true,
) => {
  return {
    language,
    encodedParameters,
    limit,
    offset,
    includeTermCounts,
    termIds,
    text,
    geoFilter,
    includeLocations,
    useLocationsFormat,
  };
};

export default createJobSearchParams;
